import { useRef, useEffect } from 'react';

export default function useLeftClick(handler) {
    const targetElement = useRef();

    let leftClickCapture;

    useEffect(() => {
        leftClickCapture = (event) => {
            // {/* ManasaB : 13-06-2024 : Changed to left click in grid : Start */ }
            if (targetElement.current && !targetElement.current.contains(event.target) && event?.button === 0) {
                handler();
            }
            else {
            }
            // {/* ManasaB : 13-06-2024 : Changed to left click in grid :End */ }
        };
        document.addEventListener('click', leftClickCapture);
        return () => {
            document.removeEventListener('click', leftClickCapture);
        };
    }, []);

    return [targetElement];

}